module.exports = __webpack_public_path__ + "static/media/1.4f54f2e7.jpg";